/* tslint:disable */
import { RefEquipment } from './ref-equipment';

/**
 */
export class ViewEquipment {
    mine?: RefEquipment[];
    others?: RefEquipment[];
    ID_USER?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/view-equipment.ts